export enum LoggedUserType {
	IS_GUEST = 'IS_GUEST',
	LOGGED = 'LOGGED',
}
